import React from 'react'
import toReduxFormBool from '../../../enhancers/ToReduxFormBool'

import { InputSwitch, Icon, Button, Input } from './styles'

const Component = ({
  className,
  input,
  disabled,
  checked,
  handleChange,
  ...otherProps
}) => {
  // removing unsafe properties: https://stackoverflow.com/questions/50170127/react-hoc-dom-properties-are-triggering-unknown-event-handler-property
  const { onChangeCallback, ...safeProps } = otherProps
  return (
    <InputSwitch
      className={className}
      checked={checked}
      disabled={disabled}
      data-testid={
        otherProps['data-testid'] ? otherProps['data-testid'] + '-label' : ''
      }
    >
      <Button checked={checked}>
        <Input
          type="checkbox"
          {...input}
          checked={checked}
          disabled={disabled}
          onChange={handleChange}
          {...safeProps}
        />
        <Icon name="checkmark" checked={checked} disabled={disabled} />
        <Icon name="x" checked={!checked} disabled={disabled} />
      </Button>
    </InputSwitch>
  )
}

export default toReduxFormBool(Component)
